import {
  AuthorizationSettings,
  initializeCustomerHubHttp,
  initializePricingHttp,
  initializeProductCatalogueHttp,
  initializeSiteSettingsHttp,
  initializeStoreApiHttp,
  setMavenoidApiConfig,
  SfccSettings,
  SiteContext,
} from '@gn-audio/jss-core';

import { PublicEnvironmentConfigs } from 'common/types/commonTypes';

export const configurePricingApi = (sfccSettings: SfccSettings, isSFCCPricingOn: boolean) => {
  initializePricingHttp({
    baseUrl: sfccSettings.shopApiBaseUrl ?? '',
    marketLocale: sfccSettings.shopApiLocale ?? '',
    isSFCCPricingOn: isSFCCPricingOn,
    shopApiClientId: sfccSettings.shopApiClientId ?? '',
  });
};

export const configureMavenoidApi = (authSettings: AuthorizationSettings) => {
  setMavenoidApiConfig({
    scopes: authSettings?.mavenoidAPIScopes ?? [],
  });
};

export const initializeHttpClients = (
  envConfig: PublicEnvironmentConfigs,
  siteContext: SiteContext
) => {
  const {
    siteSettingsApiBaseUrl,
    productCatalogueBaseUrl,
    productCatalogueApiKey,
    customerHubSubscriptionKey,
  } = envConfig || {};

  initializeCustomerHubHttp({
    subscriptionKey: customerHubSubscriptionKey,
    baseUrl: '/api/customer-hub', // Next.js API route due to issues with the CORS policy
  });

  if (siteSettingsApiBaseUrl) {
    initializeSiteSettingsHttp({
      siteContext: siteContext,
      baseUrl: siteSettingsApiBaseUrl,
    });
  }

  if (productCatalogueBaseUrl) {
    initializeProductCatalogueHttp({
      baseUrl: productCatalogueBaseUrl,
      apiKey: productCatalogueApiKey,
    });
  }

  initializeStoreApiHttp({ baseUrl: '' });
};
